import { readBookings } from '@/helpers/externals/bookings'

const state = {
  bookings: []
}

const getters = {
  getBookings: state => [...state.bookings],
  getBookingById: (state) => (id) => {
    return state.bookings.find(booking => booking.id === id)
  },
}

const mutations = {
  setBookings(state, payload) {
    state.bookings = payload.map(booking => {
      return {
        id: booking.pk,
        dropoff_time: booking.fields.dropoff_time,
        pickup_time: booking.fields.pickup_time,
        price: booking.fields.due_amount_including_taxes,
        state: booking.fields.state,
        bill_user_pdf: booking.fields.bill_user_pdf,
        credit_note_user_pdf: booking.fields.credit_note_user_pdf,
        purchases: booking.fields.purchases,
        order: booking.fields.order !== null ? booking.fields.order.fields : null,
      }
    })
  },
  clearBookings(state) {
    state.bookings = []
  },
  setBookingState(state, payload) {
    state.bookings = state.bookings.map(booking => {
      if (booking.id !== payload.booking_id) {
        return booking
      }
      const b = { ...booking }
      b.state = payload.booking_state
      return b
    })
  },
}

const actions = {
  async getBookings() {
    await readBookings()
  },
  setBookingState({ commit }, payload) {
    commit('setBookingState', payload)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}